import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../endpoint";

// Thunk to fetch all experts
export const fetchPartner = createAsyncThunk(
  "partner/fetchAll",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endpoints.serverBaseUrl}api/partner`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching experts:", error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
export const fetchpartnerbyId = createAsyncThunk(
  "partner/fetchpartnerbyId",
  async (partnerId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endpoints.serverBaseUrl}api/partner/${partnerId}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching expert by ID:", error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
const partnerSlice = createSlice({
  name: "partner",
  initialState: {
    partner: [],
    fetchById: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch all experts
      .addCase(fetchPartner.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPartner.fulfilled, (state, action) => {
        state.loading = false;
        state.partner = action.payload.data;
      })
      .addCase(fetchPartner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch single expert
      .addCase(fetchpartnerbyId.pending, (state) => {
        state.loading = true;
        state.fetchById = null;
        state.error = null;
      })
      .addCase(fetchpartnerbyId.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchById = action.payload.data || {}; // Ensure it never stays null
      })

      .addCase(fetchpartnerbyId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default partnerSlice.reducer;
